import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectPremium } from '~/containers/Auth/selectors';
import Promo from '~/containers/Promo';

const AccessControl = ({ access, children }) => {
  if (access) {
    return children;
  }

  return <Promo inDocumentFlow />;
};

export default connect(
  createStructuredSelector({
    access: selectPremium,
  }),
)(AccessControl);
